var wedding_additional_field = `
<label>Include Wedding Photo? </label>
<select class="wed-add-field" data-title="Wedding Photo">
 <option data-title="Wedding Photo" value="Yes, I will email over after the order is submitted">Yes, I will email over after the order is submitted</option>
 <option data-title="Wedding Photo" value="Prefer not to include">Prefer not to include</option>
</select>
<label>Sign-off Names (Optional)</label>
<input type="text" class="wed-add-field" data-title="Sign-off Names">
<label>Wedding Date (Optional)</label>
<input type="text" class="wed-add-field" data-title="Wedding Date" placeholder="DD/MM/YYYY">
<label>Message (Optional)</label>
<input type="text" class="wed-add-field" data-title="Message">
<label>I would like to join the Photogenic Couple Contest.</label>
<input type="checkbox" class="wed-add-field" data-title="Photogenic Couple Contest" value="true">
<p class="" style="display: inline;">Join now</p>
`

var baby_additional_field = `
<label>Baby's/Babies' Photo?</label>
<select class="baby-add-field" data-title="Wedding Photo">
 <option data-title="Baby's/Babies' Photo?" value="Yes, I will email over after the order is submitted">Yes, I will email over after the order is submitted</option>
 <option data-title="Baby's/Babies' Photo?" value="No, I prefer to use Baby icon. ">No, I prefer to use Baby icon. </option>
</select>
<label>Sign-off Names (Optional)</label>
<input type="text" class="baby-add-field" data-title="Sign-off Names">
<label>Baby/Babies's Names (Optional)</label>
<input type="text" class="baby-add-field" data-title="Baby/Babies's Names">
<label>Date of Birth (Optional)</label>
<input type="text" class="baby-add-field" data-title="Date of Birth" placeholder="DD/MM/YYYY">
<label>Birth Height (in cm) (Optional)</label>
<input type="text" class="baby-add-field" data-title="Birth Height (in cm)">
<label>Birth Weight (in kg) (Optional)</label>
<input type="text" class="baby-add-field" data-title="Birth Weight (in kg)">
<label>Message (Optional)</label>
<input type="text" class="baby-add-field" data-title="Message">
<label>I would like to join the Photogenic Baby Contest.</label>
<input type="checkbox" class="baby-add-field" data-title="Photogenic Baby Contest" value="true">
<p class="" style="display: inline;">Join now</p>
`

$(function(){
  // console.log('document ready');
})


renderCardDiv = (handle, evt) => {
  var card_type = $(evt).attr('data-type');

  if (card_type == "wedding") {
    $.getJSON('/products/' + handle + '.js', function (product, textStatus) {
      // console.log(product,textStatus);

      // Image and also all the related field
      var _image = product.featured_image;
      var _select = "<select class='card-select card-select"+card_type+"' data-type='"+card_type+"' onchange='changeVariantImg(this)'><option value='' selected disabled>Select a option</option>"
      for (var i = 0; i < product.variants.length; i++) {
        _image = product.variants.length == 1 ? product.featured_image : product.variants[i].featured_media.preview_image.src ;
        _select += "<option value='"+product.variants[i].id+"' data-image='"+_image+"'>"+product.variants[i].title+"</option>"
      }

      _select += "</select>";

      var _Img = "<img class='wedding-img' src='"+product.featured_image+"'>"
      $('.wed-1').empty().append(_Img);
      $('.wed-2').empty().append(_select);
      $('.wed-btn').show();
      if (!product.tags.includes('no-personalisation')) {
        $('.additional-field-wedding').empty().append(wedding_additional_field);
      }
    });
  }
  else {
    $.getJSON('/products/' + handle + '.js', function (product, textStatus) {
      // console.log(product,textStatus);

      // Image and also all the related field
      var _image = product.featured_image;
      var _select = "<select class='card-select card-select"+card_type+"' data-type='"+card_type+"' onchange='changeVariantImg(this)'><option value='' selected disabled>Select a option</option>"
      for (var i = 0; i < product.variants.length; i++) {
        _image = product.variants.length == 1 ? product.featured_image : product.variants[i].featured_media.preview_image.src ;
        _select += "<option value='"+product.variants[i].id+"' data-image='"+_image+"'>"+product.variants[i].title+"</option>"
      }

      _select += "</select>";

      var _Img = "<img class='baby-img' src='"+product.featured_image+"'>"
      $('.baby-1').empty().append(_Img);
      $('.baby-2').empty().append(_select);
      $('.wed-btn').show();
      if (!product.tags.includes('no-personalisation')) {
        $('.additional-field-baby').empty().append(baby_additional_field);
      }
    });
  }

}

changeVariantImg = (a) => {
  var val =(a.value || a.options[a.selectedIndex].value);  //crossbrowser solution =);
  var _image = a.options[a.selectedIndex].getAttribute("data-image");
  var _type = a.getAttribute("data-type");
  $('.'+_type+'-img').attr('src', _image);

}

checkSelectedVid = () => {
  var gotError = false;
  var params = [];
  $('.card-select').each(function(){
    var _vid = this.options[this.selectedIndex].value;
    var _type = this.getAttribute('data-type');
    var _properties = {};

    if (_type == "wedding") {
      $('.additional-field-wedding .wed-add-field').each(function(){
        var $this = $(this);
        if ($this.attr('type') == "checkbox") {
          $this.prop("checked") ==  true ? _properties[$this.attr('data-title')] = "Yes" : _properties[$this.attr('data-title')] = "No";
        }
        else {
          _properties[$this.attr('data-title')] = $this.val();
        }
      })
    }
    else {
      $('.additional-field-baby .baby-add-field').each(function(){
        var $this = $(this);
        if ($this.attr('type') == "checkbox") {
          $this.prop("checked") ==  true ? _properties[$this.attr('data-title')] = "Yes" : _properties[$this.attr('data-title')] = "No";
        }
        else {
          _properties[$this.attr('data-title')] = $this.val();
        }

      })
    }

    if (_vid) {
      params.push(
        {
          'id' : _vid,
          'qty': 1,
          'properties': _properties
        }
      )
      // $.post('/cart/add.js', {
      //   quantity: 1,
      //   id: ,
      //   properties: _properties
      // });
    }
    else {
      gotError = true;
      $('.variant-select-error').show();
    }

  })
  if (gotError == false) {
    $('.variant-select-error').hide().text('Adding...').css('color', 'black');
    MGUtil.begin(params);
    setTimeout(() => location.reload(), 2000);
  }


}
